var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconChevron = function SvgS2IconChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.823 7.965c.06.013.117.034.178.034.06 0 .118-.021.178-.034.05-.01.102-.01.15-.03.058-.023.107-.068.16-.104.042-.03.09-.047.127-.084l.003-.004.004-.003 4.075-4.125a.875.875 0 1 0-1.244-1.23L5.001 5.88 1.548 2.385a.875.875 0 1 0-1.244 1.23L4.379 7.74l.004.003.003.004c.037.037.085.055.127.084.053.036.102.08.16.104.048.02.1.02.15.03Z"
  })));
};
export default SvgS2IconChevron;